import type { UpdateYourWebsitePage } from '../types';

export const LABELS: Record<UpdateYourWebsitePage, string> = {
  start: 'See more',
  legal: 'See more',
  calculator: 'Invite your developer',
  'invite-your-developer': 'See more',
  'invite-your-developer-success': 'See more',
};
